import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, Divider, Image, } from '@chakra-ui/react';
import iconSuccess from 'assets/icons/icon-success.svg';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { OpenSuccessDialogProps } from './SuccessDialogContext';

type Props = Partial<OpenSuccessDialogProps> & {
  isOpen: boolean,
  onClose: () => void
}

export default function SuccessDialog({ title, description, actionButtonText, actionButton, closeButtonText, isOpen, onClose }: Props) {
  const cancelRef = React.useRef();
  const navigate = useNavigate();

  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isOpen={isOpen}
      isCentered
    >
      <AlertDialogOverlay />

      <AlertDialogContent>
        <AlertDialogHeader
          display="flex"
          flexDir="column"
          alignItems="center"
        >
          <Image src={iconSuccess} mb="16px" />
          {title}
        </AlertDialogHeader>
        <AlertDialogBody textAlign="center">
          {description}
        </AlertDialogBody>

        <Divider />

        <AlertDialogFooter gap="12px">
          <Button 
            onClick={() => {
              onClose();

              if (actionButton) {
                setTimeout(() => {
                  if (typeof(actionButton) === 'string')
                    navigate(actionButton);
                  else if (typeof(actionButton) === 'function')
                    actionButton();
                } , 150)
              }
            }}
            size="sm" 
          >
            {actionButtonText}
          </Button>
          <Button 
            ref={cancelRef} 
            variant="primary" 
            size="sm" 
            onClick={onClose}
          >
            {closeButtonText}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
